import { render, staticRenderFns } from "./booksToReadWeb.vue?vue&type=template&id=2eeacbe2&scoped=true&"
import script from "./booksToReadWeb.vue?vue&type=script&lang=js&"
export * from "./booksToReadWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeacbe2",
  null
  
)

export default component.exports